const copy = () => {

  const copyBtn = document.querySelector(".copy-link-form__footer-buttons button[type='submit']");
  const urlTextArea = document.querySelector(".copy-modal form textarea");



  if(copyBtn) {
    copyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      navigator.clipboard.writeText(urlTextArea.value);

      let tooltip = document.createElement('div');
      tooltip.classList.add('tooltip');
      tooltip.classList.add('--hidden');
      tooltip.innerText = copyBtn.getAttribute('data-tooltip-text');

      copyBtn.parentElement.append(tooltip);

      setTimeout(function () {
        tooltip.classList.remove('--hidden');
      }, 50);

      const delayInMilliseconds = 3000;

      setTimeout(function () {
        tooltip.classList.add("--hidden");
      }, delayInMilliseconds);
    });
  }
}

copy();
